import { EventType, PreventArchivingType } from "@/graphql";
import { computed, type ComputedRef } from "vue";
import { useSQDCGlobalSettings } from "@/modules/sqdc/helper/useSQDCGlobalSettings";
import { useTranslation } from "@/language/translation";

export function useEventArchive(
  computedProps: ComputedRef<{
    preventsArchiving?: PreventArchivingType;
    actions: { id?: number; preventsArchiving: boolean }[];
    event?: EventType | undefined;
  }>,
) {
  const { archiveWithoutTasks } = useSQDCGlobalSettings();

  const blockingTask = computed(() =>
    computedProps.value.actions.filter((action) => action.preventsArchiving),
  );

  const archivingBlocked = computed(() => {
    return (
      computedProps.value.actions.some((action) => action.preventsArchiving) ||
      (!archiveWithoutTasks.value &&
        computedProps.value.actions.length === 0 &&
        computedProps.value.event != EventType.AuditResult) ||
      !!computedProps.value.preventsArchiving
    );
  });

  const { t } = useTranslation();
  const archivingBlockedReason = computed(() => {
    if (computedProps.value.actions.length === 0 && !archiveWithoutTasks.value) {
      return t("components.issueModal.archivingWithoutTasksNotAllowed");
    }
    if (computedProps.value.preventsArchiving === PreventArchivingType.SOURCE_WITHOUT_FEEDBACK) {
      return t("components.eventActionBoard.IssueConfigButtonList.archiveBlockedOpenCopies");
    }
    if (computedProps.value.preventsArchiving === PreventArchivingType.FORWARD_WITHOUT_FEEDBACK) {
      return t("components.eventActionBoard.IssueConfigButtonList.archiveBlockedNoFeedback");
    }
    if (
      computedProps.value.preventsArchiving === PreventArchivingType.IHFailureNoticeFaultTimeEnd
    ) {
      return t("components.eventActionBoard.IssueConfigButtonList.archiveBlockedFaulTimeEnd");
    }
    if (blockingTask.value.length > 0) {
      return t("components.eventActionBoard.IssueConfigButtonList.taskAndIHOrderOpen");
    }
    return t("components.eventActionBoard.IssueConfigButtonList.archiveBlocked");
  });

  const archivingBlockedEnum = computed(() => {
    if (computedProps.value.actions.length === 0 && !archiveWithoutTasks.value) {
      return PreventArchivingType.NO_ACTION_AVAILABLE;
    }
    if (computedProps.value.preventsArchiving != null) {
      return computedProps.value.preventsArchiving;
    }
    if (blockingTask.value.length > 0) {
      return PreventArchivingType.ACTION_STATUS;
    }
    return undefined;
  });
  return {
    archivingBlocked,
    archivingBlockedReason,
    blockingTask,
    archivingBlockedEnum,
  };
}
